<div class="select-procedures-container">
  <div class="header-section">
    <p class="title">{{ "sessions-procedures.selection" | translate }}</p>
  </div>

  <div class="header-controls">
    <lib-form-control>
      <lib-radio-group [formControl]="procedureTypeCtrl">
        <div class="checkbox-container">
          <div class="checkbox-list-item">
            <lib-radio value="APAC">{{ "nouns.apac" | translate }}</lib-radio>
          </div>
          <div class="checkbox-list-item">
            <lib-radio value="SADT">{{ "nouns.sadt" | translate }}</lib-radio>
          </div>
        </div>
      </lib-radio-group>
    </lib-form-control>
  </div>

  <div class="select-wrapper">
    <div>
      <p class="section-header">{{ "nouns.insert-procedures-combos" | translate }}</p>
    </div>

    <div #trigger class="select-trigger" [class.disabled]="disabled" (click)="togglePanel()">
      <span class="select-placeholder">{{ "sessions-protocol.selection" | translate }}</span>
      <span class="select-arrow">▼</span>
    </div>

    <app-procedures-manual-select
      [proceduresArray]="proceduresArray"
      [type]="procedureTypeConfirmed$ | async"
      [reset$]="reset$"
    >
    </app-procedures-manual-select>

    <div #panel class="select-panel" [class.open]="isPanelOpen" (scroll)="onPanelScroll($event)">
      <div class="panel-label">{{ "sessions-procedures.selection" | translate }}</div>

      <div class="search-box">
        <div class="input-container">
          <img src="assets/icons/search.svg" class="search-icon" alt="Search" />
          <input
            class="search-input"
            [formControl]="searchCtrl"
            [placeholder]="'actions.search' | translate"
            (click)="$event.stopPropagation()"
          />
        </div>
      </div>

      <div class="loader-container" *ngIf="isLoading && protocols.length === 0">
        <div class="loader-spinner"></div>
      </div>

      <div class="protocol-list" *ngIf="protocols.length > 0; else emptyState">
        <div class="protocol" *ngFor="let protocol of protocols">
          <div class="protocol-header">
            <lib-checkbox [checked]="isProtocolSelected(protocol.id)" (change)="toggleProtocolSelection(protocol)">
            </lib-checkbox>
            <span class="protocol-name">{{ protocol.name }}</span>
            <button type="button" class="expand-btn" (click)="toggleExpand(protocol.id); $event.stopPropagation()">
              <span [class.rotated]="isExpanded(protocol.id)">▼</span>
            </button>
          </div>

          <div class="procedures" *ngIf="isExpanded(protocol.id)">
            <div class="procedure-item" *ngFor="let proc of protocol.procedures || []">
              <lib-checkbox
                [checked]="isProcedureSelected(proc.id)"
                (change)="toggleProcedureSelection(proc, protocol)"
              >
              </lib-checkbox>
              <span class="procedure-description">{{ proc.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <ng-template #emptyState>
        <div class="empty-state" *ngIf="!isLoading">
          {{ "sessions-details.procedure-not-found" | translate }}
        </div>
      </ng-template>
    </div>
  </div>
</div>

<app-procedures-select-list [selectedProtocolObjects]="selectedProtocolObjects" (remove)="handleRemove($event)">
</app-procedures-select-list>
